<template>
    <div class="search-wrap">
        <div class="logo">
            <svg-icon name="logo" />
        </div>

        <i class="close" @click="close">
            <svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.225 0H3.895L0 3.895V5.22499L16.34 21.565L0 37.905V39.235L3.895 43.13H5.225L21.565 26.79L37.905 43.13H39.235L43.13 39.235V37.905L26.79 21.565L43.13 5.22499V3.895L39.235 0H37.905L21.565 16.34L5.225 0Z" />
            </svg>
        </i>

        <div class="inner input-box">
            <input type="text" v-model="keyword" @input="input" @keyup.enter="search" placeholder="" ref="input" />
            <label>Start typing to search</label>
        </div>
        <div class="list">
            <Loading v-if="is_loading" />
            <swiper v-else-if="list.length !== 0" :modules="modules" :slides-per-view="'auto'"
                :keyboard="{ enabled: true, onlyInViewport: false, }"
                :navigation="{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }" :loop="false">
                <swiper-slide v-for="(item, index) in list" :key="index">
                    <ui-link :to="item.link">
                        <figure>
                            <img :src="item.featured_image" />
                        </figure>
                        <time>{{ showDate(item.post_date) }}</time>
                        <h3 v-html="item.post_title"></h3>
                    </ui-link>
                </swiper-slide>
                <span class="arrow swiper-button-prev">
                    <svg-icon name="prev" />
                </span>
                <span class="arrow swiper-button-next">
                    <svg-icon name="next" />
                </span>
                <span class="cursor" ref="cursor" :class="{ 'show': is_show }">{{ text }}</span>
            </swiper>
        </div>
    </div>
</template>

<script>
import Hover from '@/components/ui/Hover.vue';
import Loading from './ui/Loading.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Keyboard } from 'swiper/modules';
import moment from 'moment';
import 'swiper/scss';


export default {
    name: 'Navi',

    data() {
        return {
            list: [],
            is_open: false,
            keyword: '',
            is_loading: false,
            timeout: null,
        }
    },

    // watch: {
    //     '$route.params': {
    //         handler() {
    //             this.is_open_search = this.$route.name === 'search';
    //             this.keyword = this.$route.query.key_word;
    //         },
    //         immediate: true,
    //     }
    // },

    setup() {
        return {
            modules: [Navigation, Keyboard],
        };
    },

    components: {
        Loading,
        Hover,
        Swiper,
        SwiperSlide,
    },

    methods: {
        showDate(date) {
            return moment(date).format('DD MMMM, YYYY');
        },
        // search() {
        //     if (this.keyword && this.keyword !== '') {
        //         this.$router.push({
        //             path: '/search/',
        //             query: {
        //                 key_word: this.keyword
        //             }
        //         });
        //     }
        // },

        input() {
            this.is_loading = true;
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                if (this.keyword && this.keyword !== '') {
                    this.search();
                } else {
                    this.is_loading = false;
                }
            }, 500);
        },

        search() {
            this.$ajax.get(`/search?keyword=${this.keyword}`).then(res => {
                console.log(res.data.list)
                this.list = res.data.list;
                this.is_loading = false;
            });
        },

        open() {
            this.is_open = true;

            setTimeout(() => {
                this.$refs.input.focus();
                document.documentElement.classList.add('disabled-scroll');
                document.body.classList.add('open-search');
            }, 10);

        },

        close() {
            document.body.classList.remove('open-search');

            setTimeout(() => {
                document.documentElement.classList.remove('disabled-scroll');
                this.is_open = false;
            }, 330);
        },

        // toggle() {
        //     document.documentElement.classList.toggle('disabled-scroll');
        //     document.body.classList.toggle('open-search');
        // },

        keyEvent(event) {

            switch (event.key) {
                case 'Escape':
                    if (document.body.classList.contains('open-search')) {
                        document.body.classList.remove('open-search');
                        document.documentElement.classList.remove('disabled-scroll');
                    }
                    break;

            }
        }
    },

    mounted() {
        this.EventBus.on('toggle-search', () => {
            this.open();
        });

        window.addEventListener('keydown', this.keyEvent);
    },

}
</script>

<style lang="scss">
body.open-search .search-wrap {
    transform: translate(0, 0%);
}

.search-wrap {
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(21px);
    transition: transform .6s ease-in-out;
    transform: translate(0, -200%);
    display: grid;
    grid-template-rows: auto auto 1fr;
    grid-template-columns: 100%;

    .close {
        position: absolute;
        right: var(--padding-x2);
        top: 12rem;
        height: 3rem;
        width: 3rem;
        cursor: pointer;
        z-index: 99;

        svg {
            display: block;
            height: 100%;
            width: 100%;
        }

        @media screen and (max-width: 768px) {
            top: 5rem;
            height: 2.4rem;
            width: 2.4rem;

        }
    }

    .logo {
        position: relative;
        width: 90%;
        padding-top: 5vh;
        margin: 0 5%;

        &>svg {
            fill: var(--font-color);
            height: 15vh;
            width: 100%;
            display: block;
            margin: 0 auto;
        }


        @media screen and (max-width: 768px) {
            top: 4rem;
            width: 46rem;
            height: 10rem;
            margin: 0 auto;
            left: 20%;
            transform: translateX(-30%);

            svg {
                height: 100%;
                width: 100%;
            }
        }
    }

    .input-box {
        padding: 5vh 0;
        width: 100%;
        box-sizing: border-box;
        padding-left: var(--padding-x2);
        padding-right: var(--padding-x2);

        input {
            display: block;
            width: 100%;
            font-size: var(--big-size);
            background-color: transparent;
            color: var(--font-color);
            border: none;
            margin-bottom: var(--padding);

            &:focus {
                outline: none;
            }

            &::placeholder {
                color: var(--font-color);
            }
        }
    }

    .list {
        background-color: var(--theme-1);
        position: relative;

        .loading-wrap {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            height: 4rem;
            width: 4rem;
        }
    }

    .swiper {
        width: 100%;
        padding: var(--padding-x4);
        box-sizing: border-box;

        .arrow {
            position: absolute;
            top: 50%;
            height: 8rem;
            width: 8rem;
            margin-top: -8rem;
            cursor: pointer;
            z-index: 9;
            opacity: 1;
            transition: opacity .3s ease;

            svg {
                display: block;
                height: 100%;
                width: 100%;
                fill: white;
            }

            &.swiper-button-next {
                right: var(--padding-x2);
            }

            &.swiper-button-prev {
                left: var(--padding-x2);
            }

            &.swiper-button-disabled {
                opacity: 0;
                pointer-events: none;
            }

            @media screen and (max-width: 768px) {
                height: 6rem;
                width: 6rem;
                top: 50%;
                transform: translateY(-50%);

                &.swiper-button-next {
                    right: var(--padding);
                }

                &.swiper-button-prev {
                    left: var(--padding);
                }
            }
        }

        .swiper-slide {
            width: 30rem;
            box-sizing: border-box;
            padding: 0 var(--padding);

            a {
                display: block;

                figure {
                    position: relative;

                    &::before {
                        display: block;
                        padding: 0 0 100%;
                        content: '';
                    }

                    img {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        cursor: pointer;
                        left: 0;
                        top: 0;
                        object-fit: cover;
                    }
                }

                time {
                    font-size: var(--small-size);
                    color: white;
                    margin-top: var(--padding);
                    display: block;
                }

                h3 {
                    font-size: var(--base-size);
                    color: var(--font-color);
                    color: white;
                    font-weight: normal;
                }
            }

            // @media screen and (max-width: 768px){
            // }
        }

    }
}
</style>
